import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  private refreshTrigger$ = new ReplaySubject<void>(0);

  public get refreshTrigger(): Observable<void> {
    return this.refreshTrigger$.asObservable();
  }

  public trigger(): void {
    this.refreshTrigger$.next()
  }
}
